import { TRANSPARENT_OPTION } from 'pages/Batch/configs';

import type { IReduxState } from 'types';

const getBatch = (state: IReduxState) => state.batch;
export const getBatchEraserItem = (state: IReduxState) => getBatch(state).eraserItem;
export const getBatchActiveCustomBG = (state: IReduxState) => getBatch(state).activeCustomBg;
export const getBatchActiveRgb = (state: IReduxState) => getBatch(state).activeColor;
export const getObjectPosition = (state: IReduxState) => getBatch(state).objectPosition;
export const getBgToolRatio = (state: IReduxState) => getBatch(state).bgToolRatio;
export const getUserWatermarks = (state: IReduxState) => getBatch(state).userWatermarks.slice().reverse();
export const getBackgroundCustomImages = (state: IReduxState) => getBatch(state).backgroundCustomImages;
export const getSuggestedBackgrounds = (state: IReduxState) => getBatch(state).suggestedBackgrounds;
export const getCreditsData = (state: IReduxState) => getBatch(state).creditsData;
export const getPreviewCollection = (state: IReduxState) => getBatch(state).previewCollection;
export const getActivePreviewItem = (state: IReduxState) => getBatch(state).activePreviewItem;
export const getToolPrice = (state: IReduxState) => getBatch(state).toolPrice;
export const getAIBackgrounds = (state: IReduxState) => getBatch(state).generatedBackgrounds;
export const getForegroundTransforms = (state: IReduxState) => getBatch(state).foregroundTransforms;
export const getForegroundTransform = (state: IReduxState, key: string) => getBatch(state).foregroundTransforms[key];
export const getForegroundContentBboxes = (state: IReduxState) => getBatch(state).foregroundContentBboxes;
export const getForegroundContentBbox = (state: IReduxState, key: string) => getBatch(state).foregroundContentBboxes[key];
export const hasAnyAIBackground = (state: IReduxState) => getBatch(state).generatedBackgrounds.length > 0;
export const getWatermarkItemSettings = (state: IReduxState) => getBatch(state).watermarkItemSettings;
export const getBackgroundItemSettings = (state: IReduxState) => getBatch(state).backgroundItemSettings;
export const getBackgroundItemSetting = (state: IReduxState, key: string) => getBatch(state).backgroundItemSettings[key];
export const getResizeItemSettings = (state: IReduxState) => getBatch(state).resizeItemSettings;
export const getResizeItemSetting = (state: IReduxState, key: string) => getBatch(state).resizeItemSettings[key];
export const getCropAlign = (state: IReduxState) => getBatch(state).cropAlign;
export const getCropOrientation = (state: IReduxState) => getBatch(state).cropOrientation;
export const getCropTemplate = (state: IReduxState) => getBatch(state).cropTemplate;
export const getCropAttrs = (state: IReduxState) => getBatch(state).cropAttrs;
export const getCropRotate = (state: IReduxState) => getBatch(state).cropRotate;
export const getCropFlip = (state: IReduxState) => getBatch(state).cropFlip;

export const getEnhanceMapping = (state: IReduxState) => getBatch(state).enhanceMapping;

export const getBatchActiveColor = (state: IReduxState) => {
  const activeRgb = getBatchActiveRgb(state);
  return activeRgb ? `rgb(${activeRgb.r}, ${activeRgb.g}, ${activeRgb.b})` : TRANSPARENT_OPTION;
};

export const getEnhanceBeforeAfter = (state: IReduxState) => state.batch.enhanceBeforeAfter;

export const getLastAIBGPrompt = (state: IReduxState) => getBatch(state).lastAIBGPrompt;
export const getIsToolApplying = (state: IReduxState) => state.batch.isToolApplying;
export const getHasUsedSubscriptionTool = (state: IReduxState) => getBatch(state).hasUsedSubscriptionTool;

export const getWfxSelectedEffect = (state: IReduxState) => getBatch(state).wfxSelectedEffect;
export const getWfxActiveTab = (state: IReduxState) => getBatch(state).wfxActiveTab;
export const getWfxSelectedOverlay = (state: IReduxState) => getBatch(state).wfxSelectedOverlay;
export const getWfxShowSettings = (state: IReduxState) => getBatch(state).wfxShowSettings;
export const getWfxParamValues = (state: IReduxState) => getBatch(state).wfxParamValues;
export const getWfxProcessAttrs = (state: IReduxState) => getBatch(state).wfxProcessAttrs;
export const getAdjustProcessAttrs = (state: IReduxState) => getBatch(state).adjustProcessAttrs;

export const getEnhanceSelectedSmartAdjustment = (state: IReduxState) => getBatch(state).enhanceSelectedSmartAdjustment;
export const getEnhanceSelectedBackgroundBlur = (state: IReduxState) => getBatch(state).enhanceSelectedBackgroundBlur;
export const getEnhanceSmartAdjustmentIntensity = (state: IReduxState) => getBatch(state).enhanceSmartAdjustmentIntensity;
export const getEnhanceBackgroundBlurIntensity = (state: IReduxState) => getBatch(state).enhanceBackgroundBlurIntensity;
export const getEnhanceActiveSection = (state: IReduxState) => getBatch(state).enhanceActiveSection;
export const getEnhanceItemIntensities = (state: IReduxState) => getBatch(state).enhanceItemIntensities;
export const getEnhanceActiveSubtool = (state: IReduxState) => getBatch(state).enhanceActiveSubtool;
